interface ArrowLeftIconProps {
  width: number;
  height: number;
}

export const ArrowLeftIcon = ({ width, height }: ArrowLeftIconProps) => {
  return (
    <svg
      width={width} //42
      height={height} //32
      viewBox="0 0 42 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="40" height="34" rx="7" fill="#F2F2F2" />
      <rect
        x="1"
        y="1"
        width="40"
        height="34"
        rx="7"
        stroke="#E6E6E6"
        strokeWidth="2"
      />
      <path
        d="M23.0002 23.28L18.6536 18.9333C18.1402 18.42 18.1402 17.58 18.6536 17.0666L23.0002 12.72"
        stroke="#2F2F2F"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
